import { TablePlaceholderCell } from './TablePlaceholderCell';
import { StyledTableRow, TableRowCells } from './TableRow.styled';
import { TablePlaceholderRowProps } from './types';

export const TablePlaceholderRow = <TEntity extends unknown>(
  props: TablePlaceholderRowProps<TEntity>,
) => {
  const { columns, style } = props;

  return (
    <StyledTableRow role="row" style={style}>
      <TableRowCells $highlighted={false} $selectable={false} $selected={false} $static={true}>
        {columns.map(column => (
          <TablePlaceholderCell column={column} key={column.id.toString()} />
        ))}
      </TableRowCells>
    </StyledTableRow>
  );
};
